import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { bindActionCreators } from 'redux'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import * as ExplorerActions from '@disco/state-management/actions/ExplorerActions'
import { addNestedTracksToMain } from '@disco/state-management/actions/NestingActions'
import {
  resetSelection,
  selectExplorerItems,
} from '@disco/state-management/actions/SelectionActions'
import { deletePlaylist } from '@disco/state-management/actions/ServerActions'
import { createNewShortlist } from '@disco/state-management/actions/ShortlistActions'
import { makeGetTrackPlaylists } from '@disco/state-management/selectors/playlists'
import { getTrack } from '@disco/state-management/selectors/tracks'
import { getHideAutoPlaylistsSetting } from '@disco/state-management/selectors/user'
import { getAlbumPlaylistId } from '@disco/utils/playlistTypes'

import type { ExplorerPane } from 'types/explorer'
import type { Playlist } from 'types/playlist'
import type { Track } from 'types/track'

import EmptyList from '../empty-list'
import PaneItems from '../pane-items'

function mapStateToProps(state, props) {
  const getTrackPlaylists = makeGetTrackPlaylists()
  return {
    track: getTrack(state, {
      id: props.pane.id,
    }),
    trackPlaylists: getTrackPlaylists(state, {
      id: props.pane.id,
    }),
    hideAutoPlaylists: getHideAutoPlaylistsSetting(state),
    explorerSelection: state.selection.explorerSelection,
    mobileDeviceType: state.app.mobileDeviceType,
    // junk
    playlistTypes: state.entities.playlistTypes,
    groups: state.groups.groups,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    {
      ...ExplorerActions,
      resetSelection,
      selectExplorerItems,
      createNewShortlist,
      deletePlaylist,
      sendMixpanelEvent,
      addNestedTracksToMain,
    },
    dispatch,
  )
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type OwnProps = {
  pane: ExplorerPane
  onDrop: (...args: Array<any>) => any
  selectedItems: Record<string, any>[]
  shareableChannelsEnabled: boolean
}

export type Props = PropsFromRedux & OwnProps

const TrackPane = (props: Props) => {
  const { pane, playlistTypes, trackPlaylists, hideAutoPlaylists } = props
  const albumType = getAlbumPlaylistId(playlistTypes)
  let items = trackPlaylists
  if (!items || !items.length) return <EmptyList pane={pane} />

  if (hideAutoPlaylists) {
    items = items.filter(item => {
      return !(item.types && item.types.some(t => t.id === albumType))
    })
  }

  return (
    // @ts-expect-error
    <PaneItems itemPrefix="track-playlists" items={items} {...props} />
  )
}

export default connector(TrackPane)
